import React, { ReactNode, useCallback, useEffect, useRef } from 'react';
import {
    BackgroundModal,
    CloseModalButton,
    ModalContent,
    ModalWrapper,
} from './styles';
import { AnimatePresence } from 'framer-motion';
import animations from '../../helpers/animations';
import { createPortal } from 'react-dom';

type ModalProps = {
    showModal: boolean;
    setShowModal: (visibility?: boolean) => void;
    title: string;
    children: ReactNode;
    stylesChildren?: React.CSSProperties;
};

export const Modal: React.FC<ModalProps> = ({
    showModal,
    title,
    children,
    stylesChildren,
    setShowModal,
}) => {
    const modalRef = useRef<HTMLDivElement | null>(null);

    const closeModal = useCallback(
        (e: React.MouseEvent<HTMLDivElement>) => {
            if (modalRef.current === e.target) {
                setShowModal(false);
            }
        },
        [setShowModal]
    );

    const keyPress = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape' && showModal) {
                setShowModal(false);
            }
        },
        [setShowModal, showModal]
    );

    useEffect(() => {
        document.addEventListener('keydown', keyPress);

        //retirando o overflow externo quando tiver aberto
        if (showModal) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';

        return () => {
            document.removeEventListener('keydown', keyPress);
            document.body.style.overflow = 'auto';
        };
    }, [keyPress, showModal]);

    // if (!showModal) return null;

    return createPortal(
        <AnimatePresence>
            {showModal && (
                <BackgroundModal
                    ref={modalRef}
                    onClick={closeModal}
                    {...animations.fadeInOut(0.1)}
                >
                    <ModalWrapper>
                        <>
                            <p>{title}</p>
                            <CloseModalButton onClick={() => setShowModal()} />
                        </>
                        <ModalContent style={stylesChildren}>
                            {children}
                        </ModalContent>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>,
        document.getElementById('root')!
    );
};
